import React, { useEffect, useState } from "react";
import { useSetState, useBoolean } from "ahooks-v2";
import { Button } from "@t8891/pc-v1";
import VerificationCodeItem from "../../common/VerificationCodeItem";
import BrandKindSelect from "@Components/common/smallBrandKindSelect/brandKindSelect";
import Success from "./Success";
import { Modal } from "@t8891/pc-v1";
import { gaEvent } from "@Lib/ga";
import { host } from "@Services/url";
import { article } from "@Api";
import RegionItem from "./RegionItem";
import { useQuery } from "react-query";
import { fetchInquiryRegion, fetchInquiryKind, fakeInquiry } from "@Services/api";
import cx from "classnames";
import "@Styles/global.less";
import styles from "./AskPriceModal.module.less";
import Cookies from "js-cookie";
import { message } from "antd";
import qs from "qs";

let isClose = false;

interface IProps {
  setVisible: any;
  kindId: string;
  type?: string;
  brandId: string;
  activityStatus: number;
}

const { fetchV3Articles, fetchNewCarBrands, fetchNewCarKinds } = article;

const AskPrice: React.FC<IProps> = ({ type, setVisible }) => {
  const [state, { toggle }] = useBoolean(false);
  const [visibleRule, setRule] = useState(false);
  const [params, setParams] = useSetState({
    agencyAgreement: 0,
    isNameEmpty: false,
    protect: false,
    code: "",
    name: "",
    mobile: "",
    isCode: "",
    isName: "",
    isCar: "",
    isMobile: "",
    codeVerify: 0,
    regions: {},
  });
  const { isCode, isCar, name, isMobile, isName, protect, agencyAgreement, isNameEmpty, mobile, regions, codeVerify } =
    params;
  const [success, setSuccess] = useState({
    visible: false,
    mobile: "",
  });
  const [newCarKind, setNewCarKind] = useState<any[]>([]);
  const [newCarDataSource, setNewCarDataSource] = useState<IDataSource>({
    index: [],
    brand: [],
    kindNum: 0,
  });
  const [query, setQuery] = useSetState<any>({
    kindId: undefined,
    brandId: undefined,
  });

  const fetchRegion = async (brandId) => {
    const resRegion = await fetchInquiryRegion({ b: brandId });

    if (resRegion?.status === 12000) {
      setParams({
        regions: resRegion.data,
      });
    }
  };

  useEffect(() => {
    // gaEvent("銷售線索（曝光）", "買車頁-推廣彈窗-直接詢價", "一鍵詢價")

    let inquiryData = localStorage.getItem("inquiryData")
      ? JSON.parse(localStorage.getItem("inquiryData") as string)
      : {};
    if (Object.keys(inquiryData).length ^ 0) {
      setParams({ ...inquiryData, protect: true });
    } else {
      // refetch();
    }

    fetchSelect();
    gaEvent("搶購趴活動（曝光）", "右側彈窗", "立即詢價");
  }, []);

  function onValChange(e, obName) {
    let values = e.currentTarget.value,
      isName = "",
      isMobile = "",
      isCode = "";

    if (obName === "name" && values === "") {
      isName = "請輸入稱呼";
    }

    if (obName === "mobile") {
      if (values === "") {
        isMobile = "請輸入手機號";
      } else if (!/^09\d{8}$/.test(values)) {
        isMobile = "請輸入正確的手機號";
      }
    }

    if (obName === "code") {
      if (codeVerify === 1 && values === "") {
        isCode = "驗證碼不能為空！";
      } else if (codeVerify === 1 && values.length != 6) {
        isCode = "驗證碼長度不正確";
      }
    }

    setParams({
      [obName]: obName !== "mobile" ? values : values.replace(/[^\d]/g, ""),
      isCode: isCode,
      isName: isName,
      isMobile: isMobile,
    });

    if (codeVerify === 0 && obName === "mobile") {
      setParams({
        codeVerify: 1,
      });
    }
  }

  const fetchSelect = async () => {
    const res = await fetchNewCarBrands({ type: "inquiry" });

    if (res && res.status === 12000) {
      setNewCarDataSource(res.data);
    }
  };

  const handleNewCarBrandSelect = async (brand: number) => {
    setNewCarKind([]);
    setQuery({ brandId: brand });
    const res = await fetchNewCarKinds({ b: brand, type: "inquiry" });
    if (res && res.status === 12000) {
      setNewCarKind(res.data.data);
    }
  };

  async function submit() {
    if (isClose) return;

    const { name, mobile, agencyAgreement, code, codeVerify, regions } = params;
    const { source: querySource } = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    if (!query.kindId || !query.brandId) {
      setQuery({
        isCar: "請選擇意向車款",
      });
      return false;
    }

    if (name === "") {
      let e = { currentTarget: { value: name } };
      onValChange(e, "name");
      return false;
    }

    if (mobile === "") {
      let e = { currentTarget: { value: mobile } };
      onValChange(e, "mobile");
      return false;
    }

    if (codeVerify === 1 && code === "") {
      let e = { currentTarget: { value: code } };
      onValChange(e, "code");
      return false;
    } else if (codeVerify === 1 && code.length != 6) {
      let e = { currentTarget: { value: code } };
      onValChange(e, "code");
      return false;
    }
    isClose = true;

    gaEvent("搶購趴活動", "右側彈窗", "立即詢價");

    const res = await fakeInquiry({
      b: query.brandId,
      k: query.kindId,
      name,
      mobile,
      source: Cookies.get("globalSource") || `${type === "kindsum" ? "綜述" : "菜單"}-詢成交價`,
      entrance: querySource || "",
      agencyAgreement,
      code,
      region: regions.regions[regions.selectedIndex].id,
      codeVerify,
    });

    isClose = false;

    if (res.status === 13000) {
      message.error(res.data.message);
      return;
    } else if (res.status === 12000) {
      Cookies.set("isAskPrice", "true", { expires: 30 });

      let inquiryData = {
        name,
        mobile,
        agencyAgreement,
        codeVerify: 0,
        region: regions.selectedIndex,
        inquiryId: res.data.inquiryId,
      };
      setSuccess({
        visible: true,
        mobile: res.data.mobile,
      });
      localStorage.setItem("inquiryData", JSON.stringify(inquiryData));
      setVisible(false);

      message.success("詢價成功");
      {
        type === "kindsum" ? gaEvent("銷售線索", "綜述頁", "菜單-詢成交價") : gaEvent("銷售線索", "菜單頁", "詢成交價");
      }
    }
  }

  return (
    <>
      {success.visible && <Success setVisible={setVisible} visible={success.visible} callMobile={success.mobile} />}
      {!success.visible && (
        <section className={cx(styles["AskPrice"], styles["AskPriceMenu"])}>
          <div className={styles["model-top"]}>
            <i className={styles["icon-123"]} />
            {/* <a className={styles['rule-model-btn']} onClick={() => setRule(true)}>活動規則</a> */}
          </div>
          <section className={styles["like-car"]}>
            <div className={styles["ask-label"]}>意向車款：</div>
            <BrandKindSelect
              field={"newcar"}
              selectLabel={"選擇廠牌車款"}
              dataSource={newCarDataSource}
              kindData={newCarKind}
              onBrandSelect={handleNewCarBrandSelect}
              onClear={() => {
                setQuery({
                  kindId: undefined,
                  brandId: undefined,
                });
                setQuery({
                  isCar: "",
                });
              }}
              onSubmit={(data: any) => {
                const { brandId, kindId } = data;
                setQuery({
                  brandId,
                  kindId,
                });
                setQuery({
                  isCar: "",
                });
                fetchRegion(brandId);
              }}
            />
            {!!isCar && <span className={styles["reminder"]}>{isCar}</span>}
            {/* <div className={styles['selcet-item-border']} onClick={() => {
            toggle()
          }}>
            <i className={cx(styles['arrow-icon'], {
              [styles['action']]: state
            })} />
          </div> */}
          </section>
          <div className={styles["inqupt-item"]}>
            {!!isName && <span className={styles["reminder"]}>{isName}</span>}
            <label htmlFor='稱 呼： '>
              稱<i style={{ marginLeft: "22px" }} />
              呼：{" "}
            </label>
            <input
              maxLength={10}
              value={name}
              onChange={(e) => onValChange(e, "name")}
              type='text'
              placeholder={isNameEmpty ? "請輸入稱呼" : "如：陳先生"}
            />
          </div>
          <div className={styles["inqupt-item"]}>
            {!!isMobile && <span className={styles["reminder"]}>{isMobile}</span>}
            <label htmlFor='手 機 號'>手 機 號： </label>
            <input
              type='text'
              maxLength={10}
              onClick={() => {
                setParams({
                  protect: false,
                });
              }}
              onBlur={() => {
                if (mobile.length !== 10) return;
                setParams({
                  protect: true,
                });
              }}
              onChange={(e) => onValChange(e, "mobile")}
              value={!protect ? mobile : mobile ? mobile.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2") : ""}
              placeholder={"通話免費，業代看不到您的手機號"}
            />
            <i
              className={cx(styles["protect-icon"], {
                [styles["press"]]: protect,
              })}
            />
          </div>
          {codeVerify === 1 && (
            <div className={styles["inqupt-item"]}>
              {isCode !== "" && <span className={styles["reminder"]}>{isCode}</span>}
              <label htmlFor='驗 證 碼 '>驗 證 碼： </label>
              <input
                className={styles["code"]}
                onChange={(e) => onValChange(e, "code")}
                type='tel'
                maxLength={6}
                placeholder={"請輸入驗證碼"}
              />
              <VerificationCodeItem style={{ marginLeft: "20px", float: "right" }} account={mobile} type='7' />
            </div>
          )}
          {/* {Object.keys(regions).length !== 0 && */}
          <RegionItem
            dataSource={regions}
            onClearSelect={() => message.error("請選擇意向車款！")}
            onSelectIndex={(index) => {
              let regionsData = {
                ...params.regions,
                ...{ selectedIndex: index },
              };
              setParams({
                regions: regionsData,
              });
            }}
          />
          {/* } */}
          <Button
            onClick={() => submit()}
            type='warning'
            radius
            className={`${styles["ask-btn"]} ${styles["ask-active-btn"]}`}
          >
            一鍵詢價
          </Button>
          <div className={styles["ask-item-6"]}>
            <i
              className={cx(styles["circle-icon"], {
                [styles["press"]]: agencyAgreement === 1,
              })}
              onClick={() => {
                setParams({
                  agencyAgreement: agencyAgreement == 0 ? 1 : 0,
                });
              }}
            />
            我已仔細閱讀並同意
            <a href={"https://www.8891.com.tw/help-sev.html"} target='_blank'>
              《服務條款》
            </a>
            、
            <a href={"https://www.8891.com.tw/help-article-426.html"} target='_blank'>
              《用戶須知》
            </a>
            、
            <a href={"https://www.8891.com.tw/help-laimer.html"} target='_blank'>
              《免責聲明》
            </a>
            、
            <a href={"https://www.8891.com.tw/help-pris.html"} target='_blank'>
              《隱私權聲明》
            </a>
            、
            <a href={`https://www.8891.com.tw/help-article-442.html`} target='_blank'>
              《一鍵詢價服務說明》
            </a>
            等所載內容；本功能由數字科技與數字廣告共同舉辦，點擊代表您同意將個人資料傳送給您所詢價廠牌對應經銷商等相關廠商。
          </div>
        </section>
      )}
      <Modal
        maskClosable={true}
        className={styles["rule-modal"]}
        closeLocation='top'
        visible={visibleRule}
        onClose={() => setRule(false)}
      >
        <iframe className={styles["rule-modal-iframe"]} src={`${host.c}/activity/rule?name=buying-party&header=0`} />
      </Modal>
    </>
  );
};
export default AskPrice;
